import Flex, { GAP_CLASS } from "components/Flex";
import {
  getOutlineTypeLabel,
  toConfidencePct,
} from "constants/outlineGeneration";
import { Check } from "lucide-react";
import { number, string } from "prop-types";

import classes from "./DetectedTypeBanner.module.scss";

const DetectedTypeBanner = ({ type, label, confidence }) => {
  if (!type && !label) {
    return null;
  }

  const archetypeLabel = type ? getOutlineTypeLabel(type) : null;

  const detailLabel = label || archetypeLabel;
  const showArchetypePill = archetypeLabel && archetypeLabel !== detailLabel;
  const pct = toConfidencePct(confidence);

  return (
    <Flex className={classes["banner"]} gap={GAP_CLASS.GAP_350} role="status">
      <Check
        size={16}
        className={classes["banner__check"]}
        aria-hidden="true"
      />
      <div className={classes["banner__text"]}>
        <span className={classes["banner__lead"]}>Detected Document Type</span>
        <span className={classes["banner__detail"]} title={detailLabel}>
          {detailLabel}
        </span>
      </div>
      {showArchetypePill && (
        <span className={classes["banner__archetype_pill"]}>
          {archetypeLabel}
        </span>
      )}
      <span className={classes["banner__confidence_pill"]}>
        {pct}% Confident
      </span>
    </Flex>
  );
};

DetectedTypeBanner.propTypes = {
  type: string,
  label: string,
  confidence: number,
};

export default DetectedTypeBanner;
